import { ILogger } from ".";
import { ConsoleLogger } from "./ConsoleLogger";

export class LoggerFactory {
  static getLogger(): ILogger {
    return new ConsoleLogger();
  }

  static initialize(): void {
    ConsoleLogger.initialize();
  }
}
